<template>
    <v-dialog v-model="$parent.showProcedureStagesModal" max-width="1000">
        <v-card class="pa-4">
            <v-card-title class="headline">Etapas</v-card-title>
            <v-simple-table>
                <thead>
                <tr>
                    <th class="primary--text">No.</th>
                    <th class="primary--text">Etapa</th>
                    <th class="primary--text">Estado</th>
                    <th class="primary--text">Fecha de inicio</th>
                    <th class="primary--text">Última actualización</th>
                    <th class="primary--text">Fecha de Término</th>
                    <th class="primary--text">Fecha Vencimiento</th>
                    <th class="primary--text">Días restantes</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(stage, index) in $parent.procedureStages" :key="stage.id">
                    <td>{{$parent.procedureStages.length - index}}</td>
                    <td>{{stage.task.name}}</td>
                    <td>{{stage.status.male_label}}</td>
                    <td>{{stage.created_at}}</td>
                    <td>{{stage.updated_at}}</td>
                    <td>{{stage.ended_at}}</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                </tbody>
            </v-simple-table>

        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return{
        }
    },
}
</script>